// extracted by mini-css-extract-plugin
export var container = "_3w-0";
export var error = "_3w-9";
export var label = "_3w-5";
export var light = "_3w-6";
export var md = "_3w-3";
export var sm = "_3w-2";
export var thin = "_3w-8";
export var thinBold = "_3w-7";
export var vertical = "_3w-4";
export var xs = "_3w-1";